import styled from 'styled-components';
import { Breakpoints } from '@01_people/ui-library';

export default styled.div`
  height: 72px;
  margin-bottom: 3px;
  width: 100%;
  background-color: ${({ theme }) => theme.header.backgroundColor};
  position: sticky;
  top: 0;
  z-index: 1;

  .scroll-menu-arrow {
    height: 50px;
    width: 18px;
    background: ${({ theme }) => theme.header.subColor};
    cursor: pointer;
    color: ${({ theme }) => theme.header.linkColorActive};
    display: flex;
    align-items: center;

    .arrow-prev,
    .arrow-next {
      padding: 0 6px;

      span > svg > use {
        fill: ${({ theme }) => theme.header.linkColor};
      }
    }
  }

  .scroll-menu-arrow--disabled {
    .arrow-prev,
    .arrow-next {
      visibility: hidden;
    }
  }

  .header-inner {
    background-color: ${({ theme }) => theme.header.backgroundColor};
    padding-left: 25px;
    padding-right: 25px;

    display: flex;
    justify-content: space-between;

    .header-image-wrapper {
      height: 72px;
      max-width: 160px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 10px;
      img {
        height: auto;
        max-width: 140px;
        width: auto;
        max-height: 100%;
      }
    }

    .header-back-wrapper {
      height: 72px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      button:not(:hover) {
        background-color: ${({ theme }) => theme.header.backgroundColor};
      }
    }
  }

  ul.header-menu {
    margin-bottom: 0;
    padding-left: 0;
    list-style: none;
    display: flex;
    flex-direction: row;
    justify-content: center;

    a {
      transition-property: color;
      transition-duration: 0.2s;
      transition-timing-function: ease;
      transition-delay: 0s;

      text-decoration: none;
      margin-right: 15px;

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        text-decoration: none;
        color: ${({ theme }) => theme.header.linkColorActive};
      }

      width: 130px;
      height: 100%;

      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;

      font-size: 16px;
      font-weight: bold;
      line-height: 1.5;
      color: ${({ theme }) => theme.header.linkColor};

      cursor: pointer;

      &.active {
        border-bottom: 3px solid ${({ theme }) => theme.header.barColor};
        height: 75px;
        color: ${({ theme }) => theme.header.linkColorActive};
      }

      &:not(.active) {
        height: 72px;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }

  @media (max-width: ${Breakpoints.maxMedium}) {
    ul.header-menu {
      li {
        font-size: 14px;
      }
    }
    .header-outer {
      height: 104px;

      .header-inner {
        height: 75px;

        .responsive-close-btn {
          padding-top: 26px;
          cursor: pointer;
          svg {
            g {
              fill: ${({ theme }) => theme.header.linkColor};
            }
          }
        }

        .header-image-wrapper {
          height: 100%;
          width: auto;
        }

        .header-back-wrapper {
          height: 56px;
        }
      }
    }

    div.menu-item-wrapper {
      a {
        div {
          &.active {
            height: 50px;
            color: ${({ theme }) => theme.header.linkColorActive};
          }
          &:not(.active) {
            height: 47px;
          }
        }
      }
    }
  }

  @media (max-width: ${Breakpoints.maxSmall}) {
    height: 104px;

    .header-outer {
      .header-inner {
        height: 56px;
        .responsive-close-btn {
          padding-top: 16px;
        }
      }
    }

    .responsive-subheader {
      height: 48px;
      border-top: solid 1px ${({ theme }) => theme.header.backgroundColor};
      background-color: ${({ theme }) => theme.header.subColor};
      .horizontal-menu {
        height: 100%;
      }

      .menu-wrapper {
        background-color: ${({ theme }) => theme.header.subColor};
      }

      div.menu-item-wrapper {
        min-width: 100px;
        height: 100%;
        font-size: 14px;
        font-weight: bold;
        line-height: 1.5;
        margin: 0 5px 0 5px;
        background-color: ${({ theme }) => theme.header.subColor};

        a {
          transition-property: color;
          transition-duration: 0.2s;
          transition-timing-function: ease;
          transition-delay: 0s;

          color: ${({ theme }) => theme.header.linkColor};
          text-decoration: none;

          text-align: center;
          display: flex;
          justify-content: center;
          flex-direction: column;

          &:hover {
            color: ${({ theme }) => theme.header.linkColorActive};
            text-decoration: none;
          }

          &.active {
            border-bottom: 3px solid ${({ theme }) => theme.header.barColor};
            height: 50px;
            color: ${({ theme }) => theme.header.linkColorActive};
          }
          &:not(.active) {
            height: 47px;
          }
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
`;
